export default __webpack_public_path__ + "static/media/SE0.db40debf.png";